export default __webpack_public_path__ + "static/media/out_point_charge.341c49fd.svg";